export const terms = {
  it: {
    title: "Termini di Servizio",
    section1: {
      title: "1. Accettazione dei Termini",
      content: "Accedendo e utilizzando questo sito web, accetti di essere vincolato da questi Termini di Servizio e da tutte le leggi e i regolamenti applicabili. Se non sei d'accordo con qualsiasi parte di questi termini, non puoi utilizzare i nostri servizi."
    },
    section2: {
      title: "2. Licenza d'Uso",
      content: "È concesso il permesso di accedere temporaneamente a questo sito web solo per uso personale e non commerciale. Questa è la concessione di una licenza, non un trasferimento di titolo, e in base a questa licenza non puoi:",
      items: [
        "Modificare o copiare i materiali",
        "Utilizzare i materiali per scopi commerciali",
        "Rimuovere notazioni di copyright o altre proprietà",
        "Trasferire i materiali a un'altra persona",
        "Tentare di decompilare o decodificare qualsiasi software"
      ]
    },
    section3: {
      title: "3. Disponibilità del Servizio",
      content: "Ci impegniamo a fornire un servizio ininterrotto ma potremmo dover eseguire manutenzione o aggiornamenti. Ci riserviamo il diritto di:",
      items: [
        "Modificare o interrompere qualsiasi parte del servizio",
        "Limitare l'accesso ad alcune o tutte le funzionalità",
        "Limitare la disponibilità del servizio in determinate regioni",
        "Sospendere gli account per violazioni"
      ]
    },
    section4: {
      title: "4. Obblighi dell'Utente",
      content: "Come utente dei nostri servizi, sei tenuto a:",
      items: [
        "Mantenere accurate le informazioni dell'account",
        "Proteggere le credenziali dell'account",
        "Utilizzare il servizio in conformità con le leggi",
        "Segnalare accessi non autorizzati",
        "Rispettare i diritti di proprietà intellettuale",
        "Non impegnarti in comportamenti abusivi o dannosi"
      ]
    },
    section5: {
      title: "5. Termini di Pagamento",
      content: "Per i servizi a pagamento:",
      items: [
        "I pagamenti sono elaborati in modo sicuro attraverso fornitori autorizzati",
        "Gli abbonamenti si rinnovano automaticamente se non cancellati",
        "I rimborsi sono soggetti alla nostra politica di rimborso",
        "I prezzi possono cambiare con preavviso"
      ]
    },
    section6: {
      title: "6. Proprietà Intellettuale",
      content: "Tutti i contenuti, le funzionalità e le funzionalità sono di proprietà di Varienda BMS e sono protetti da:",
      items: [
        "Leggi internazionali sul copyright",
        "Leggi sui marchi",
        "Leggi sui brevetti",
        "Leggi sul segreto commerciale"
      ]
    },
    section7: {
      title: "7. Limitazione di Responsabilità",
      content: "Varienda BMS non sarà responsabile per:",
      items: [
        "Danni diretti o indiretti",
        "Perdita di dati o profitti",
        "Interruzioni del servizio",
        "Azioni di terze parti"
      ]
    },
    section8: {
      title: "8. Terminazione dell'Account",
      content: "Possiamo terminare o sospendere l'accesso al nostro servizio immediatamente, senza preavviso, per:",
      items: [
        "Violazioni dei Termini",
        "Attività fraudolente",
        "Comportamento abusivo",
        "Mancato pagamento"
      ]
    },
    section9: {
      title: "9. Legge Applicabile",
      content: "Questi termini saranno regolati e interpretati in conformità con le leggi dell'Italia, senza riguardo alle sue disposizioni sui conflitti di legge."
    },
    section10: {
      title: "10. Modifiche ai Termini",
      content: "Ci riserviamo il diritto di modificare questi termini in qualsiasi momento. Notificheremo agli utenti eventuali modifiche sostanziali tramite email o notifica del servizio."
    },
    lastUpdated: "Ultimo aggiornamento: 30 marzo 2024"
  },
  en: {
    title: "Terms of Service",
    section1: {
      title: "1. Acceptance of Terms",
      content: "By accessing and using this website, you agree to be bound by these Terms of Service and all applicable laws and regulations. If you do not agree with any part of these terms, you are prohibited from using our services."
    },
    section2: {
      title: "2. Use License",
      content: "Permission is granted to temporarily access this website for personal, non-commercial use only. This is the grant of a license, not a transfer of title, and under this license you may not:",
      items: [
        "Modify or copy the materials",
        "Use the materials for any commercial purpose",
        "Remove any copyright or other proprietary notations",
        "Transfer the materials to another person",
        "Attempt to decompile or reverse engineer any software"
      ]
    },
    section3: {
      title: "3. Service Availability",
      content: "We strive to provide uninterrupted service but may need to perform maintenance or updates. We reserve the right to:",
      items: [
        "Modify or discontinue any part of the service",
        "Limit access to some or all features",
        "Restrict service availability in certain regions",
        "Suspend accounts for violations"
      ]
    },
    section4: {
      title: "4. User Obligations",
      content: "As a user of our services, you are required to:",
      items: [
        "Maintain accurate account information",
        "Protect account credentials",
        "Use the service in compliance with laws",
        "Report unauthorized access",
        "Respect intellectual property rights",
        "Not engage in abusive or harmful behavior"
      ]
    },
    section5: {
      title: "5. Payment Terms",
      content: "For paid services:",
      items: [
        "Payments are processed securely through authorized providers",
        "Subscriptions auto-renew unless cancelled",
        "Refunds are subject to our refund policy",
        "Prices may change with notice"
      ]
    },
    section6: {
      title: "6. Intellectual Property",
      content: "All content, features, and functionality are owned by Varienda BMS and are protected by:",
      items: [
        "International copyright laws",
        "Trademark laws",
        "Patent laws",
        "Trade secret laws"
      ]
    },
    section7: {
      title: "7. Limitation of Liability",
      content: "Varienda BMS will not be liable for:",
      items: [
        "Direct or indirect damages",
        "Loss of data or profits",
        "Service interruptions",
        "Third-party actions"
      ]
    },
    section8: {
      title: "8. Account Termination",
      content: "We may terminate or suspend access to our service immediately, without notice, for:",
      items: [
        "Terms violations",
        "Fraudulent activities",
        "Abusive behavior",
        "Non-payment"
      ]
    },
    section9: {
      title: "9. Governing Law",
      content: "These terms shall be governed and construed in accordance with the laws of Italy, without regard to its conflict of law provisions."
    },
    section10: {
      title: "10. Changes to Terms",
      content: "We reserve the right to modify these terms at any time. We will notify users of any material changes via email or service notification."
    },
    lastUpdated: "Last updated: March 30, 2024"
  }
};